'use client'

import React, { useRef, useState } from 'react'
import ProductCardSearch from '@/components/Catalog/ProductCardSearch'
import SearchResultsBoundary from '@/components/Catalog/SearchResultsBoundary'
import { BORDERED_INPUT_CLASS } from '@/components/Form/Input/classes'
import { useProductSearch } from '@/hooks/business/catalog'
import { useClickOutside } from '@/hooks/ui'

/**
 * Busca da listagem `/produtos`: autocomplete pela busca do catálogo (`product/search`, a mesma do Navbar), com os
 * produtos em lista e link para a PDP. A lista fecha ao escolher um produto ou clicar fora, e volta quando o texto muda.
 */
const SearchBar: React.FC = () => {
    const [keyword, setKeyword] = useState('')
    const { results, term } = useProductSearch(keyword)
    const [closedTerm, setClosedTerm] = useState<string | null>(null)
    const listRef = useRef<HTMLDivElement>(null)

    const isOpen = results.length > 0 && closedTerm !== term
    const close = () => setClosedTerm(term)

    useClickOutside(listRef, close, isOpen)

    return (
        <div className="relative">
            <input
                type="search"
                placeholder="Pesquisar produtos..."
                className={`w-full ${BORDERED_INPUT_CLASS}`}
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
            />
            {isOpen && (
                <div
                    className="absolute left-0 right-0 z-50 max-h-screen p-2 pb-5 mt-1 overflow-auto bg-white shadow-md top-full"
                    ref={listRef}
                >
                    <SearchResultsBoundary resetKey={term}>
                        {results.map((result) => (
                            <ProductCardSearch key={result.id} data={result} clear={close} />
                        ))}
                    </SearchResultsBoundary>
                </div>
            )}
        </div>
    )
}

export default SearchBar
